module.exports = __webpack_public_path__ + "img/Newbie_Shield_02_Mage.18344102.png";